function offset(elt) {
  if( elt ) {
    var rect = elt.getBoundingClientRect(), bodyElt = document.body;
    return {
      top: rect.top + bodyElt .scrollTop,
      left: rect.left + bodyElt .scrollLeft
    }
  }
}
 
window.addEventListener("load", function(){
  window.scrollTo(0, 0);

  if(document.querySelector("aside")){
    const sidebar = document.querySelector("aside");
    const footer = document.querySelector("#shopify-section-footer-promotions")? document.querySelector("#shopify-section-footer-promotions") : document.querySelector(".shopify-section-group-footer-group");
    const top = offset(sidebar).top;
    const footTop = offset(footer).top;
    const maxY = footTop - sidebar.offsetHeight - 50;

    const mSidebarSelector = document.querySelector(".menu-overlay-select");
    const mSidebarMenu = document.querySelector(".menu-overlay.mobile--only .collapsible-content__inner");
    const mSidebarClose = document.querySelector(".menu-overlay.mobile--only .icon-close");
    const mSidebarLink = document.querySelector(".menu-overlay.mobile--only ul li");

    mSidebarSelector.addEventListener("click", function(){
      mSidebarMenu.classList.add('is-open');
    });
    mSidebarClose.addEventListener("click", function(){
      mSidebarMenu.classList.remove('is-open');
    });
    mSidebarLink.addEventListener("click", function(){
      mSidebarMenu.classList.remove('is-open');
    });

    window.addEventListener("scroll", function(){
      let y = document.scrollingElement.scrollTop;
      if (y > top) {
        if (y < maxY) {
          sidebar.classList.add("fixed")
        } else {
          sidebar.classList.remove("fixed")
        }
      } else {
        sidebar.classList.remove("fixed")
      }
    })
  }
});